<template>
  <div class="router-transitions container-fluid flex-grow-1 container-p-y">
    <h4 class="d-flex justify-content-between align-items-center w-100 font-weight-bold py-3 mb-4">
      <div>Users</div>
      <b-btn v-if="!scimUsersSyncEnabled" variant="primary btn-round" class="d-block" @click="userCreate">
        <span class="ion ion-md-add"></span>&nbsp;Create user
      </b-btn>
    </h4>
    <b-card no-body>
      <div class="table-responsive">
        <b-table :items="nonLocalUsers" :fields="fields" class="card-table">
          <template #head(name)="data">
            <AppTableHeadCellSort name="name" :current="params.sort" @sort="setSort">{{ data.label }}</AppTableHeadCellSort>
          </template>
          <template #head(email)="data">
            <AppTableHeadCellSort name="email" :current="params.sort" @sort="setSort">{{ data.label }}</AppTableHeadCellSort>
          </template>
          <template #head(status)="data">
            <AppTableHeadCellSort name="status" :current="params.sort" @sort="setSort">{{ data.label }}</AppTableHeadCellSort>
          </template>
          <template #head(source)="data" v-if="hasSourceColumn">
            <AppTableHeadCellSort name="scim_data" :current="params.sort" @sort="setSort">{{ data.label }}</AppTableHeadCellSort>
          </template>
          <template #cell(role)="data">
            <span v-if="data.item.role === 'userRole'">User</span>
            <span v-if="data.item.role === 'adminRole'">Admin</span>
            <span v-if="data.item.role === 'superAdminRole'">Owner</span>
          </template>
          <template #cell(status)="data">
            <b-badge variant="outline-success" v-if="+data.item.status === 0">Deleted</b-badge>
            <b-badge variant="outline-success" v-if="+data.item.status === 10">Active</b-badge>
            <b-badge variant="outline-danger" v-if="+data.item.status === 1">Inactive</b-badge>
          </template>
          <template #cell(source)="data">
            <span v-if="data.item.source === 'scim'">SCIM</span>
          </template>
          <template #cell(actions)="data">
            <b-btn variant="default btn-sm icon-btn md-btn-flat" title="Edit" @click="edit(data.item)"
              ><i class="ion ion-md-create"></i
            ></b-btn>
          </template>
        </b-table>
      </div>
      <AppPager :pager="usersPager" @change="setPage" />
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
import AppPager from '@/components/shared/AppPager'
import AppTableHeadCellSort from '@/components/shared/AppTableHeadCellSort.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import Id, { isLocalId } from '@/utils/Id'

export default {
  name: 'Users',
  components: {
    AppPager,
    AppTableHeadCellSort
  },
  data: () => ({
    params: {
      sort: 'name',
      page: '1'
    }
  }),
  computed: {
    ...mapGetters('user', ['users']),
    ...mapState('user', ['usersPager']),
    ...mapGetters('settings', ['scimUsersSyncEnabled']),
    nonLocalUsers() {
      return this.users.filter((u) => !isLocalId(u.id))
    },
    hasSourceColumn() {
      return this.scimUsersSyncEnabled
    },
    fields() {
      return [
        { key: 'name', label: 'User Name' },
        { key: 'email' },
        { key: 'status' },
        { key: 'source', enabled: this.hasSourceColumn },
        { key: 'role' },
        { key: 'actions', label: ' ', tdClass: 'text-right mr-3 text-nowrap' }
      ].filter(({ enabled }) => enabled === undefined || enabled)
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        if (from.name === 'user-edit' && to.name === 'users') {
          this.load()
        }
      }
    }
  },
  methods: {
    ...mapActions('user', ['usersLoad']),
    edit(user) {
      this.$router.push({ name: 'user-edit', params: { userId: user.id } })
    },
    userCreate() {
      this.edit({ id: Id() })
    },
    load() {
      this.usersLoad({
        params: Object.assign({ 'per-page': 50 }, this.params)
      })
      this.$router.push({ name: 'users', query: this.params })
    },
    setSort(sort) {
      this.params.sort = sort
      this.load()
    },
    setPage(page) {
      this.params.page = page
      this.load()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  },
  created() {
    this.params = { sort: 'name', ...this.$route.query }
    this.load()
  }
}
</script>

<style scoped></style>
